import { makeStyles, Theme } from "@material-ui/core/styles";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { changeAppState } from "../../../../../../../../common/appState";
import { SuccessButton } from "../../../../../../../shared/Button/SuccessButton";

export function FindFriendsButton({ noFriend }: { noFriend: boolean }) {
    const c = useStyles({ noFriend });
    return (
        <div className={c.container}>
            <SuccessButton
                className={c.button}
                startIcon={<PersonAddIcon />}
                onClick={() => {
                    changeAppState("activeUsersPanelState", { open: true });
                }}
            >
                Find new friends
            </SuccessButton>
        </div>
    );
}
const useStyles = makeStyles<Theme, { noFriend: boolean }>({
    container: ({ noFriend }) => ({
        marginBottom: noFriend ? 0 : 5,
        marginTop: noFriend ? 0 : 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxHeight: noFriend ? 0 : 30,
        transition: "all 500ms",
    }),
    button: ({ noFriend }) => ({
        maxHeight: noFriend ? 0 : 30,
        minHeight: noFriend ? 0 : 30,
        padding: noFriend ? 0 : "6px 16px",
        opacity: noFriend ? 0 : 1,
        fontSize: "15px !important",
        lineHeight: 1,
    }),
});

